import { render, staticRenderFns } from "./internationalStudents.vue?vue&type=template&id=08bccd7f"
import script from "./internationalStudents.vue?vue&type=script&lang=js"
export * from "./internationalStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports